import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-spin-footer" }
const _hoisted_2 = { class: "bonusomat-spin-footer__remain" }
const _hoisted_3 = ["innerHTML"]

import { computed } from "vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-spin-footer',
  props: {
    remainingSpinsCount: {}
  },
  emits: ["showWinnerTable"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const showWinnerTableInternal = () => emit("showWinnerTable");

const remainText = computed(() => {
    if (props.remainingSpinsCount > 0) {
        return ` K dispozici ${props.remainingSpinsCount}&nbsp;zatočení`;
    }
    return "Zatočení není k dispozici";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DsIcon, {
        class: "bonusomat-spin-footer__remain-icon",
        name: "b-mat",
        width: 24
      }),
      _createElementVNode("span", {
        class: "bonusomat-spin-footer__remain-text",
        innerHTML: remainText.value
      }, null, 8, _hoisted_3)
    ]),
    _createVNode(DsButton, {
      class: "bonusomat-spin-footer__table",
      type: "text",
      size: "sm",
      "icon-right": "money-bag-coins",
      onClick: showWinnerTableInternal
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Tabulka výher")
      ])),
      _: 1,
      __: [0]
    })
  ]))
}
}

})